<template>
  <div class="map">
    <baidu-map class="baidu-map" :ak="ak_code" :center="center" :zoom="zoom" :scroll-wheel-zoom="true">
      <bm-marker :position="markerPoint"> </bm-marker>
      <bm-overlay
        ref="customOverlay"
        class="sample"
        pane="labelPane"
        @draw="draw"
      >
        <p>上海国家会展中心6.1号馆C127号展位</p>
      </bm-overlay>
    </baidu-map>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ak_code: "SS6GGvZfEfqF0TbOWjR6N2niD7Yg8Vx0",
      center: { lng: 121.3084, lat: 31.196105 },
      zoom: 19,
      markerPoint: {
        lng: 121.3084,
        lat: 31.196105,
      },

      show: true,
    };
  },
  mounted() {},
  methods: {
    handler({ BMap, map }) {
      this.center.lng = 121.3084;
      this.center.lat = 31.196105;
      this.zoom = 19;
    },
    draw({ el, BMap, map }) {
      const { lng, lat } = this.markerPoint;
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.transform = "translate(-50%,-125%)";
      el.style.left = pixel.x + "px";
      el.style.top = pixel.y - 25 + "px";
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style> 